(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const poptexHeader = document.querySelector('.poptex-header');
  const poptexToggle = document.querySelector('[data-poptex-menu-toggle]');
  const solutionsDropdown = document.querySelector('[data-solutions-dropdown]');
  const solutionsDropdownToggle = document.querySelector('[data-solutions-dropdown-toggle]');
  const solutionsDropdownMenu = document.querySelector('[data-cms-solutions-menu]');
  const scenePageUrls = {
    'matrix-enterprise': '/pages/corporate',
    'matrix-school': '/pages/graduation-keepsakes',
    'matrix-sports-team': '/pages/sports-commemorations',
    'matrix-scenic-cultural': '/pages/souvenir-shops',
    'matrix-event-celebration': '/pages/music-festivals'
  };

  const escapeHeaderHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const getSceneSlug = (scene) => String(scene && (scene.slug || scene.handle || scene.id) || '').trim();
  const getScenePageUrl = (scene) => scenePageUrls[getSceneSlug(scene)] || `/pages/templates?scenario=${encodeURIComponent(getSceneSlug(scene))}`;
  const sortHeaderScenes = (scenes) => scenes.slice().sort((left, right) => {
    const leftSort = Number(left && left.sortOrder);
    const rightSort = Number(right && right.sortOrder);
    if (Number.isFinite(leftSort) || Number.isFinite(rightSort)) {
      return (Number.isFinite(rightSort) ? rightSort : 0) - (Number.isFinite(leftSort) ? leftSort : 0);
    }
    return String(left && left.name || '').localeCompare(String(right && right.name || ''));
  });

  const renderSolutionsMenuFromCms = (scenes) => {
    if (!solutionsDropdownMenu || !Array.isArray(scenes) || !scenes.length) return;
    solutionsDropdownMenu.innerHTML = sortHeaderScenes(scenes)
      .map((scene) => `<a href="${escapeHeaderHtml(getScenePageUrl(scene))}">${escapeHeaderHtml(scene.name || scene.title || getSceneSlug(scene))}</a>`)
      .join('');
  };

  const loadSolutionsMenuFromCms = () => {
    if (!solutionsDropdownMenu || !window.PoptexApi || typeof window.PoptexApi.getDefaultClient !== 'function') return;
    const client = window.PoptexApi.getDefaultClient();
    if (!client.cms || typeof client.cms.listScenes !== 'function') return;
    client.cms.listScenes()
      .then(renderSolutionsMenuFromCms)
      .catch((error) => {
        console.warn('POPTEX solutions menu CMS load failed:', error);
      });
  };

  if (poptexHeader && poptexToggle) {
    window.matchMedia('(max-width: 760px)').addEventListener('change', (event) => {
      if (event.matches) return;
      poptexHeader.classList.remove('is-open');
      poptexToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('poptex-menu-open');
    });

    poptexToggle.addEventListener('click', () => {
      const isOpen = poptexHeader.classList.toggle('is-open');
      poptexToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('poptex-menu-open', isOpen);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !poptexHeader.classList.contains('is-open')) return;
      poptexHeader.classList.remove('is-open');
      poptexToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('poptex-menu-open');
      poptexToggle.focus();
    });
  }

  if (solutionsDropdown && solutionsDropdownToggle) {
    solutionsDropdownToggle.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = solutionsDropdown.classList.toggle('is-open');
      solutionsDropdownToggle.setAttribute('aria-expanded', String(isOpen));
    });

    document.addEventListener('click', (event) => {
      if (solutionsDropdown.contains(event.target)) return;
      solutionsDropdown.classList.remove('is-open');
      solutionsDropdownToggle.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      solutionsDropdown.classList.remove('is-open');
      solutionsDropdownToggle.setAttribute('aria-expanded', 'false');
    });
  }

  const aiRecordStorageKey = 'poptex_ai_cases';
  const aiRecordsModal = document.querySelector('[data-ai-records-modal]');
  const aiRecordsList = document.querySelector('[data-ai-records-list]');
  const aiRecordsOpen = document.querySelector('[data-ai-records-open]');
  const aiRecordCount = document.querySelector('[data-ai-record-count]');
  const aiRecordDetail = document.querySelector('[data-ai-record-detail]');
  const aiRecordDetailTitle = document.querySelector('[data-ai-record-detail-title]');
  const aiRecordDetailCase = document.querySelector('[data-ai-record-detail-case]');
  const aiRecordDetailBody = document.querySelector('[data-ai-record-detail-body]');

  const escapeAiRecordHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const readAiRecords = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(aiRecordStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const formatAiRecordDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const getAiRecordById = (recordId) => readAiRecords().find((record) => record.id === recordId);

  const buildAiRecordDetailRow = (label, value) => {
    if (value === undefined || value === null || value === '') return '';
    return `<div><span>${escapeAiRecordHtml(label)}</span><strong>${escapeAiRecordHtml(value)}</strong></div>`;
  };

  const buildAiRecordMetric = (label, value) => {
    if (value === undefined || value === null || value === '') return '';
    return `<div class="poptex-ai-record-detail__metric"><span>${escapeAiRecordHtml(label)}</span><strong>${escapeAiRecordHtml(value)}</strong></div>`;
  };

  const normalizeAiRecordImages = (record) => {
    const storedImages = Array.isArray(record.images) ? record.images : [];
    return storedImages
      .map((image) => typeof image === 'string' ? { url: image } : image)
      .filter((image) => image && image.url);
  };

  const findAiRecordImage = (record, roles) => {
    const roleList = Array.isArray(roles) ? roles : [roles];
    return normalizeAiRecordImages(record).find((image) => roleList.includes(image.role));
  };

  const buildAiRecordVisualCard = (label, value, image) => {
    if (!value && !image) return '';
    return `
      <div class="poptex-ai-record-detail__visual-card">
        ${image && image.url ? `<img src="${escapeAiRecordHtml(image.url)}" alt="${escapeAiRecordHtml(label)}">` : ''}
        <div><span>${escapeAiRecordHtml(label)}</span><strong>${escapeAiRecordHtml(value || 'Selected')}</strong></div>
      </div>
    `;
  };

  const buildAiRecordImages = (record) => {
    const images = normalizeAiRecordImages(record);
    const mainImage = record.imageUrl || (images[0] && images[0].url) || '';
    if (!mainImage) return '';
    const allImages = images.some((image) => image.url === mainImage)
      ? images
      : [{ role: 'MAIN_EFFECT_IMAGE', url: mainImage }].concat(images);
    const roleLabels = {
      MAIN_EFFECT_IMAGE: 'Blanket Design',
      PRODUCT_IMAGE: 'Product Preview',
      USAGE_SCENE_IMAGE: 'Usage Scene',
      BRAND_MARK_DETAIL_IMAGE: 'Brand Mark',
      PACKAGING_IMAGE: 'Packaging',
      GIFT_BOX_IMAGE: 'Packaging'
    };
    const gallery = allImages.length > 1
      ? `<div class="poptex-ai-record-detail__gallery">${allImages.map((image, index) => {
          const label = roleLabels[image.role] || 'Preview';
          return `
            <button class="poptex-ai-record-detail__thumb ${index === 0 ? 'is-active' : ''}" type="button" data-ai-record-thumb="${escapeAiRecordHtml(image.url)}" data-ai-record-thumb-label="${escapeAiRecordHtml(label)}">
              <img src="${escapeAiRecordHtml(image.url)}" alt="${escapeAiRecordHtml(label)}">
              <span>${escapeAiRecordHtml(label)}</span>
            </button>
          `;
        }).join('')}</div>`
      : '';
    return `
      <div class="poptex-ai-record-detail__hero">
        <img class="poptex-ai-record-detail__main-image" src="${escapeAiRecordHtml(mainImage)}" alt="${escapeAiRecordHtml(record.title || 'AI preview')}" data-ai-record-main-image>
        ${gallery}
      </div>
    `;
  };

  const openAiRecordDetail = (recordId) => {
    const record = getAiRecordById(recordId);
    if (!record || !aiRecordDetail || !aiRecordDetailBody) return;
    const status = record.status || 'running';
    const statusMessage = status === 'completed'
      ? 'AI preview completed. Review the result and continue when ready.'
      : status === 'failed'
        ? record.error || 'AI generation failed. Please try again from the design studio.'
        : 'Generation is still running. This record will update automatically when the preview is ready.';
    const metricRows = [
      buildAiRecordMetric('Quantity', record.quantity ? `${record.quantity} pcs` : ''),
      buildAiRecordMetric('Subtotal', record.subtotal),
      buildAiRecordMetric('Unit price', record.unitPrice),
      buildAiRecordMetric('Size', record.size)
    ].filter(Boolean).join('');
    const visualRows = [
      buildAiRecordVisualCard('Brand mark', record.brandMark, findAiRecordImage(record, 'BRAND_MARK_DETAIL_IMAGE')),
      buildAiRecordVisualCard('Packaging', record.packaging, findAiRecordImage(record, ['PACKAGING_IMAGE', 'GIFT_BOX_IMAGE']))
    ].filter(Boolean).join('');
    const productTypeLabel = {
      FLANNEL_SINGLE_PRINT: 'Single-Layer Flannel - Single-Sided Print',
      FLANNEL_DOUBLE_PRINT: 'Double-Layer Flannel - Same Artwork Both Sides',
      SHERPA_FLANNEL_SINGLE_PRINT: 'Sherpa + Flannel - Printed Flannel Front'
    };
    const productType = record.productType || '';
    const detailRows = [
      buildAiRecordDetailRow('Blanket product', productTypeLabel[productType] || record.blanketStyle),
      buildAiRecordDetailRow('Packaging variant', record.variantTitle),
      buildAiRecordDetailRow('Shipping', record.shipping),
      buildAiRecordDetailRow('Source', record.source),
      buildAiRecordDetailRow('Created', formatAiRecordDate(record.createdAt)),
      buildAiRecordDetailRow('Completed', formatAiRecordDate(record.completedAt))
    ].filter(Boolean).join('');
    const images = status === 'completed' ? buildAiRecordImages(record) : '';
    const actions = status === 'completed'
      ? `
        <div class="poptex-ai-record-detail__actions">
          <button type="button" data-ai-record-pay="${escapeAiRecordHtml(record.id || '')}">Pay Now</button>
          <a href="/pages/contact-us" data-ai-record-inquiry>Send Inquiry</a>
          <button type="button" data-ai-record-detail-close>Close</button>
        </div>
      `
      : status === 'failed'
        ? `
          <div class="poptex-ai-record-detail__actions">
            <a href="/pages/contact-us" data-ai-record-inquiry>Send Inquiry</a>
            <button type="button" data-ai-record-detail-close>Close</button>
          </div>
        `
        : `
          <div class="poptex-ai-record-detail__actions">
            <button type="button" data-ai-record-detail-close>Close</button>
          </div>
        `;

    if (aiRecordDetailTitle) aiRecordDetailTitle.textContent = record.title || 'Custom blanket preview';
    if (aiRecordDetailCase) aiRecordDetailCase.textContent = record.id || 'Case';
    aiRecordDetailBody.innerHTML = `
      <div class="poptex-ai-record-detail__media">
        ${images || `<div class="poptex-ai-record-detail__status"><span>${escapeAiRecordHtml(statusMessage)}</span><span class="poptex-ai-record-card__status poptex-ai-record-card__status--${escapeAiRecordHtml(status)}">${escapeAiRecordHtml(status)}</span></div>`}
      </div>
      <div class="poptex-ai-record-detail__summary">
        <div class="poptex-ai-record-detail__status">
          <span>${escapeAiRecordHtml(statusMessage)}</span>
          <span class="poptex-ai-record-card__status poptex-ai-record-card__status--${escapeAiRecordHtml(status)}">${escapeAiRecordHtml(status)}</span>
        </div>
        <div class="poptex-ai-record-detail__metric-row">${metricRows}</div>
        ${visualRows ? `<div class="poptex-ai-record-detail__visuals">${visualRows}</div>` : ''}
        <div class="poptex-ai-record-detail__grid">${detailRows}</div>
        ${actions}
      </div>
    `;
    aiRecordDetail.hidden = false;
  };

  const closeAiRecordDetail = () => {
    if (aiRecordDetail) aiRecordDetail.hidden = true;
  };

  const submitAiRecordCheckout = async (recordId) => {
    const record = getAiRecordById(recordId);
    if (!record || !record.variantId) {
      window.alert('Please return to the design studio to checkout.');
      return;
    }
    const shopUrl = record.shopUrl || window.location.origin;
    try {
      await window.PoptexCommerce.replaceCart([{
        id: record.variantId,
        quantity: record.quantity || 1,
        properties: {
          'AI Case': record.id || '',
          'Product Type': productTypeLabel[record.productType] || record.blanketStyle || '',
          'Product Type Code': record.productType || '',
          Size: record.size || '',
          'Brand Mark': record.brandMark || '',
          Packaging: record.packaging || '',
          'Packaging Variant': record.variantTitle || '',
          'Shipping Method': record.shipping || ''
        }
      }]);
      window.location.href = `${shopUrl.replace(/\/$/, '')}/checkout`;
    } catch (error) {
      window.alert(error?.message || 'Checkout is temporarily unavailable.');
    }
  };

  const renderAiRecords = () => {
    const records = readAiRecords();
    const runningCount = records.filter((record) => record.status === 'running').length;
    if (aiRecordCount) {
      aiRecordCount.hidden = runningCount === 0;
      aiRecordCount.textContent = String(runningCount);
    }
    if (!aiRecordsList) return;
    if (!records.length) {
      aiRecordsList.innerHTML = '<p>No AI records yet.</p>';
      return;
    }
    aiRecordsList.innerHTML = records.map((record) => {
      const status = escapeAiRecordHtml(record.status || 'running');
      const image = record.imageUrl
        ? `<img src="${escapeAiRecordHtml(record.imageUrl)}" alt="${escapeAiRecordHtml(record.title || 'AI preview')}">`
        : '';
      return `
        <article class="poptex-ai-record-card" role="button" tabindex="0" data-ai-record-id="${escapeAiRecordHtml(record.id || '')}">
          <header>
            <div>
              <h3>${escapeAiRecordHtml(record.title || 'Custom blanket preview')}</h3>
              <small>${escapeAiRecordHtml(record.id || '')} · ${escapeAiRecordHtml(formatAiRecordDate(record.createdAt))}</small>
            </div>
            <span class="poptex-ai-record-card__status poptex-ai-record-card__status--${status}">${status}</span>
          </header>
          ${image}
          <div class="poptex-ai-record-card__meta">
            <span>${escapeAiRecordHtml(record.subtotal || '')}</span>
            <span>${escapeAiRecordHtml(record.quantity ? `${record.quantity} pcs` : '')}</span>
            <span>${escapeAiRecordHtml(record.packaging || '')}</span>
            <span>${escapeAiRecordHtml(record.shipping || '')}</span>
          </div>
        </article>
      `;
    }).join('');
  };

  if (aiRecordsOpen) {
    aiRecordsOpen.addEventListener('click', () => {
      window.location.href = aiRecordsOpen.dataset.aiRecordsResultsUrl || '/pages/ai-records';
    });
  }

  document.querySelectorAll('[data-ai-records-close]').forEach((button) => {
    button.addEventListener('click', () => {
      if (aiRecordsModal) aiRecordsModal.hidden = true;
    });
  });

  if (aiRecordsList) {
    aiRecordsList.addEventListener('click', (event) => {
      const card = event.target.closest('[data-ai-record-id]');
      if (!card) return;
      openAiRecordDetail(card.getAttribute('data-ai-record-id'));
    });
    aiRecordsList.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const card = event.target.closest('[data-ai-record-id]');
      if (!card) return;
      event.preventDefault();
      openAiRecordDetail(card.getAttribute('data-ai-record-id'));
    });
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ai-record-detail-close]')) closeAiRecordDetail();
    const thumb = event.target.closest('[data-ai-record-thumb]');
    if (thumb && aiRecordDetail) {
      const mainImage = aiRecordDetail.querySelector('[data-ai-record-main-image]');
      if (mainImage) {
        mainImage.src = thumb.getAttribute('data-ai-record-thumb') || mainImage.src;
        mainImage.alt = thumb.getAttribute('data-ai-record-thumb-label') || mainImage.alt;
      }
      aiRecordDetail.querySelectorAll('[data-ai-record-thumb]').forEach((button) => {
        button.classList.toggle('is-active', button === thumb);
      });
    }
    const payButton = event.target.closest('[data-ai-record-pay]');
    if (payButton) submitAiRecordCheckout(payButton.getAttribute('data-ai-record-pay'));
  });

  window.addEventListener('storage', (event) => {
    if (event.key === aiRecordStorageKey) renderAiRecords();
  });
  window.addEventListener('poptex:ai-cases-updated', renderAiRecords);
  window.addEventListener('DOMContentLoaded', loadSolutionsMenuFromCms, { once: true });
  window.addEventListener('poptex:metadata-updated', loadSolutionsMenuFromCms);
  renderAiRecords();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  const howItWorksPage = document.querySelector('[data-how-it-works-page]');

  if (howItWorksPage) {
    const stepsViewport = howItWorksPage.querySelector('.how-it-works__steps');
    const steps = Array.from(howItWorksPage.querySelectorAll('.how-step'));
    const scrollButtons = Array.from(howItWorksPage.querySelectorAll('.how-step__scroll[href^="#"]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setActiveStep = (activeStep) => {
      const activeIndex = steps.indexOf(activeStep);

      steps.forEach((step, index) => {
        step.classList.toggle('is-active', index === activeIndex);
        step.classList.toggle('is-before', index < activeIndex);
        step.classList.toggle('is-after', index > activeIndex);
      });
    };

    steps.forEach((step, index) => {
      step.classList.toggle('is-active', index === 0);
      step.classList.toggle('is-before', false);
      step.classList.toggle('is-after', index > 0);
    });

    if ('IntersectionObserver' in window && stepsViewport) {
      const observer = new IntersectionObserver((entries) => {
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visibleEntry) {
          setActiveStep(visibleEntry.target);
        }
      }, {
        root: stepsViewport,
        threshold: [0.45, 0.6, 0.75]
      });

      steps.forEach((step) => observer.observe(step));
    }

    scrollButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = howItWorksPage.querySelector(button.getAttribute('href'));

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
